<template>
  <div >
  <div class="loadingdiv" v-if="loading">
  <img style="padding-top:100px;" width="50"  src="@/images/spinner.svg"  />
  </div>

    <div class="editor-container" v-if="loaded">

  <div class="editor-full">
        <new-editor   :onDragOver="handleDragOver"
    :onDrop="handleDrop" ref="immiEditor" :token="token" :editing="editing" :title="title" :documentContent="sfdtContent" v-model="editorContent" ></new-editor>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';


import mammoth from 'mammoth/mammoth.browser.js';
import NewEditor from './NewEditor.vue'

export default {
  components: {
    NewEditor
  },
  data() {
    return {
      loading:false,
      loaded:false,
      sfdtContent:'',
      editorContent: '',
            templateId: '',
            url:null,
      editing:false,
      token: '',
      title:'',
      reqPayload:'',
      fields:[],
      callbackUrl:'',
      recipients:[]	
    };
  },
  computed: {
    editorOptions() {
      return {
        modules: {
          toolbar:{
               container: [
                       [{ 'header': [1, 2, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'script': 'sub'}, { 'script': 'super' }],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }, { 'indent': '-1'}, { 'indent': '+1' }],
            [{ 'direction': 'rtl' }, { 'align': [] }],
            ['link', 'image', 'video'],
            ['clean'],
                  ]
          } 
        }
      };
    }
  },
  methods: {
        handleDragStart(text) {
      event.dataTransfer.setData("text/plain", text);
    },
    handleDrop(event) {
      const text = event.dataTransfer.getData("text/plain");
      this.insertTextAtCursor(text);
    },
    insertTextAtCursor(text) {
      const documentEditor = this.$refs.immiEditor.$children[0].ej2Instances.documentEditor;
      if (documentEditor && documentEditor.selection) {
        documentEditor.editor.insertText(text);
      }
    },
    async saveAndRedirect() {
  const apiUrl = process.env.VUE_APP_API_URL; // Access the environment variable

this.loading = true;
try {
     const documentEditor = this.$refs.immiEditor.$children[0].ej2Instances.documentEditor;
   const sfdtContent = documentEditor.serialize();
   const docxBlob = await documentEditor.saveAsBlob('Docx');
        const files = [docxBlob]; 

        const formData = new FormData();
        files.forEach((fileItem) => {
            formData.append('files', fileItem, `${this.title}.docx`);
        });

        // Append additional data to the FormData
        formData.append('secureType', 'private');

        const s3response = await axios.post(`${apiUrl}/s3/upload`, formData, {
            headers: {
                'Authorization': `Bearer ${this.token}`,
                'Content-Type': 'multipart/form-data'
            }
        });
      console.log("s3responses3responses3response")
        console.log(s3response)
        var document = {};
        if(s3response.data.result && s3response.data.result.length > 0){
          document = {
          'name':this.title,
          'path':s3response.data.result[0]['path'],
          'mimetype':"application/vnd.openxmlformats-officedocument.wordprocessingml.document",
           'extn':'docx'

        }

        }

        

        const response = await axios.post(`${apiUrl}/templates/update`, {
            templateId: this.templateId,
            sfdtContent:sfdtContent,
            worddocument:document
          }, {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          });
          var data = response.data;
          console.log(data)

             // Post message to parent window and close the popup
    if (response.status === 200) {
      window.opener.postMessage('closePopup', '*');
      //window.close();
    }
         // window.location.href = this.callbackUrl+'?templateId='+this.templateId+'&reqPayload='+this.reqPayload;


         } catch (error) {
          console.error('Error posting template details:', error);
        }


    },
 insertText: function(textToInsert) {
        // Access the DocumentEditor instance
        const documentEditor = this.$refs.immiEditor.$children[0].ej2Instances.documentEditor;
        console.log(documentEditor)
        // Check if the DocumentEditor is loaded and has a selection
        if (documentEditor && documentEditor.selection) {
            // Insert text at the current cursor position
            documentEditor.editor.insertText('{'+textToInsert+'}');
        }
    },

    selectWordFile() {
      this.$refs.fileInput.click();
    },
        extractParams() {
      const queryParams = new URLSearchParams(window.location.search);
      this.templateId = queryParams.get('templateId');
      this.token = queryParams.get('token');
  this.editing = queryParams.get('view') === 'true';
  this.url = queryParams.get('url');
this.title= queryParams.get('name');
    },
    async postTemplateDetails() {
  const apiUrl = process.env.VUE_APP_DOCUMENTEDITOR_URL; // Access the environment variable
  const queryParams = new URLSearchParams(window.location.search);

  if (this.url && this.token) {
    try {
      // Fetch the file from the S3 URL
  // Fetch the file from the S3 URL
     const fileResponse = await axios.get(this.url, {
        responseType: 'blob' // Ensure the response is treated as an array buffer
      });




      // Create a FormData object and append the Blob
      const formData = new FormData();
      formData.append('files', fileResponse.data,  queryParams.get('name')+'.docx'); // Provide a filename


      // Post the file to the API
      const response = await axios.post(`${apiUrl}Import`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      this.sfdtContent = response.data; // Assuming the response contains `sfdt` field
      this.loaded = true;
      this.loading = false;
    } catch (error) {
      console.error('Error posting template details:', error);
    }
  }else{
    this.sfdtContent = ''
      this.loaded = true;
      this.loading = false;

  }
},
    importWordDocument(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          mammoth.convertToHtml({ arrayBuffer: e.target.result })
            .then((result) => {
              this.editorContent = result.value;
            })
            .catch(err => console.error(err));
        };
        reader.readAsArrayBuffer(file);
      }
    }
  },
  mounted() {
    this.loading = true;
    this.extractParams();
    this.postTemplateDetails()
   
  }
}
</script>
